const config={
    // localhost_url:'http://192.168.0.25:8089',
    // localhost_url:'http://localhost:8089',
    // localhost_url:'http://ec2-54-149-62-15.us-west-2.compute.amazonaws.com:8089', //new dev
    // localhost_url:'http://ec2-34-214-32-243.us-west-2.compute.amazonaws.com:8089', //new test
    localhost_url:'https://load.goslash.com', //prod
}

export default config;